export const getGccApiClientInit = (state) => state.gccApiConnection.gccApiClientInit;
